/**
 * Inline SVG icons, drawn on a 24×24 grid with a 2px stroke so they sit
 * together at any size. Kept here rather than pulled from a package: the set is
 * small, and an icon library would be most of a megabyte for a dozen glyphs.
 */
const PATHS = {
  apps: "M12 2l9 5-9 5-9-5 9-5zM3 12l9 5 9-5M3 17l9 5 9-5",
  team: "M17 20v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9.5 10a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM22 20v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75",
  key: "M15 7a4 4 0 1 1-3.9 5H8v3H5v3H2v-3.5L10.5 8.5A4 4 0 0 1 15 7z",
  rocket: [
    "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z",
    "M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z",
  ],
  globe:
    "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM3.6 9h16.8M3.6 15h16.8M12 3a15 15 0 0 1 0 18 15 15 0 0 1 0-18z",
  settings:
    "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6h.09A1.65 1.65 0 0 0 10.6 3.09V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z",
  logs: "M4 6h16M4 12h16M4 18h10",
  clock: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7v5l3 2",
  plus: "M12 5v14M5 12h14",
  check: "M20 6L9 17l-5-5",
  close: "M6 6l12 12M18 6L6 18",
  menu: "M4 7h16M4 12h16M4 17h16",
  chevron: "M9 6l6 6-6 6",
  "chevron-down": "M6 9l6 6 6-6",
  "arrow-up-right": "M7 17L17 7M8 7h9v9",
  logout: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9",
  search: "M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM21 21l-4.35-4.35",
  copy: "M9 9h10v12H9zM5 15H3V3h12v2",
  trash: "M4 7h16M10 11v6M14 11v6M5 7l1 14h12l1-14M9 7V4h6v3",
  // A die with its pins, for the AI model catalogue. Deliberately not a
  // sparkle: every product on the internet uses one for anything touching AI,
  // and the rail lists things you can build with, not things that are trendy.
  models: [
    "M9 9h6v6H9z",
    "M4 8h1M4 12h1M4 16h1M19 8h1M19 12h1M19 16h1M8 4v1M12 4v1M16 4v1M8 19v1M12 19v1M16 19v1",
    "M5 5h14v14H5z",
  ],
  warning: "M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z",
  branch: "M6 3v12M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM18 9a9 9 0 0 1-9 9",
  lock: "M5 11h14v10H5zM8 11V7a4 4 0 0 1 8 0v4",
  eye: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
  "eye-off":
    "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24M1 1l22 22",
  link: "M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.5 1.5M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7L12 19",
  refresh: "M21 12a9 9 0 1 1-3-6.7M21 3v6h-6",
  card: "M3 10h18M7 15h4M3 6h18a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1z",
  /*
   * A cache hit: the store, plus the bolt that says it came back fast.
   *
   * Distinct from `database`, which names a managed Postgres or Redis a customer
   * runs. This one marks a request whose prompt the provider had already seen,
   * and the two appear on different screens for different reasons — one glyph
   * doing both jobs would be a database icon on a row that has no database.
   */
  cache: [
    "M3.5 5.2c0-1.2 2.5-2.2 5.5-2.2s5.5 1 5.5 2.2-2.5 2.2-5.5 2.2-5.5-1-5.5-2.2z",
    "M3.5 5.2v5.1c0 1.1 2.1 2 4.8 2.2M3.5 10.3v5.1c0 1.1 2.1 2 4.8 2.2",
    "M17 11.5l-3.2 5h2.7L15.4 22l4.1-6h-2.9l1.4-4.5z",
  ],
  database: "M12 8c4.4 0 8-1.34 8-3s-3.6-3-8-3-8 1.34-8 3 3.6 3 8 3zM4 5v14c0 1.66 3.6 3 8 3s8-1.34 8-3V5M4 12c0 1.66 3.6 3 8 3s8-1.34 8-3",
  /* A stack of plates seen in isometric — the same construction as `apps`, so a
     container image and an app read as related shapes. */
  container: "M21 8L12 3 3 8m18 0v8l-9 5-9-5V8m18 0l-9 5m0 0L3 8m9 5v8",
  shield: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z",
  /* Arrow into a tray. The tray line matters: without it this is indistinguishable
     from `chevron-down` at 14px, which is the size it is actually used at. */
  download: "M12 3v12M7 11l5 5 5-5M4 20h16",
  /* A megaphone, for operator notices. Same drawing as the operator console's,
     because the two sets are deliberately one style — see the header. */
  announcements: [
    "M3 11v2a1 1 0 0 0 1 1h3l7 4V6l-7 4H4a1 1 0 0 0-1 1z",
    "M7 14v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2",
    "M18 9a4 4 0 0 1 0 6",
  ],
  /*
   * A life ring, for support. Not a speech bubble: the rail already has one
   * conversational glyph in `announcements`, and the two would read as the same
   * thing at 14px — one is us talking, this is you asking.
   */
  support: [
    "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z",
    "M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z",
    "M5.6 5.6l3.9 3.9M14.5 14.5l3.9 3.9M18.4 5.6l-3.9 3.9M9.5 14.5l-3.9 3.9",
  ],
  /* The same glyph the marketing site draws for its documentation, so the rail
     item and the page it opens are marked the same way. */
  book: "M4 19.5V5a2 2 0 0 1 2-2h13v18H6a2 2 0 0 1-2-2zM19 17H6a2 2 0 0 0-2 2",
  paperclip:
    "M21.4 11.05l-9.2 9.19a5 5 0 0 1-7.07-7.07l9.2-9.19a3.33 3.33 0 0 1 4.71 4.71l-9.19 9.2a1.67 1.67 0 0 1-2.36-2.36l8.49-8.48",
  send: ["M22 2L11 13", "M22 2l-7 20-4-9-9-4 20-7z"],
  gift: [
    "M4 8h16a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z",
    "M12 8v13",
    "M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7",
    "M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5",
  ],
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, className = "size-5" }: { name: IconName; className?: string }) {
  const paths = PATHS[name];
  const list: readonly string[] = typeof paths === "string" ? [paths] : paths;

  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
    >
      {list.map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}

/**
 * Git host wordmarks.
 *
 * Separate from `Icon` because these are filled shapes at a fixed weight, not
 * 2px strokes — rendering them through the stroked set would smear them. Paths
 * are the vendors' own marks, so they stay recognisable at 16px, which is the
 * whole point of showing a logo rather than a label.
 */
const PROVIDER_PATHS = {
  github:
    "M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12",
  gitlab:
    "m23.6 9.6-.03-.09-3.26-8.5a.85.85 0 0 0-.34-.4.87.87 0 0 0-1 .05.87.87 0 0 0-.29.45l-2.2 6.73H7.52L5.32 1.1a.86.86 0 0 0-.29-.45.87.87 0 0 0-1-.05.85.85 0 0 0-.34.4L.42 9.5l-.03.09a6.05 6.05 0 0 0 2 7l.01.01.03.02 4.96 3.72 2.46 1.86 1.5 1.13a1.01 1.01 0 0 0 1.22 0l1.5-1.13 2.46-1.86 5-3.74.01-.01a6.05 6.05 0 0 0 2-7z",
  bitbucket:
    "M.778 1.213a.768.768 0 0 0-.768.892l3.263 19.81c.084.5.515.868 1.022.873H19.95a.772.772 0 0 0 .77-.646l3.27-20.03a.768.768 0 0 0-.768-.891zM14.52 15.53H9.522L8.17 8.466h7.561z",
} as const;

export type ProviderName = keyof typeof PROVIDER_PATHS;

export function ProviderMark({
  provider,
  className = "size-5",
}: {
  provider: string;
  className?: string;
}) {
  const path = PROVIDER_PATHS[provider as ProviderName];
  if (!path) return <Icon name="branch" className={className} />;

  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className}>
      <path d={path} />
    </svg>
  );
}

/** The stacked-plates mark, shared with the marketing site. */
export function LogoMark({ className = "size-7" }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" className={className}>
      <defs>
        {/* Accent into mint, matching the marketing site's mark exactly. */}
        <linearGradient id="ml-logo" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="var(--color-accent)" />
          <stop offset="100%" stopColor="var(--color-mint)" />
        </linearGradient>
      </defs>
      <path d="M16 3.5 29 11 16 18.5 3 11z" fill="url(#ml-logo)" />
      <path
        d="M4.5 15.6 16 22.2l11.5-6.6"
        fill="none"
        stroke="var(--color-brand-500)"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.7"
      />
      <path
        d="M4.5 20.6 16 27.2l11.5-6.6"
        fill="none"
        stroke="var(--color-brand-500)"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.35"
      />
    </svg>
  );
}
